import React from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import Api from 'shared/src/apis/apiTags';
import {
  onSettledT,
  onMutateCreateT,
  onMutateDeleteT,
  onMutateUpdateT,
  Q_DEF_RETRY,
  Q_STALE_TMO_CFG,
  mutationFnUpdateT,
} from 'shared/src/utils/utils';
import { g_Auth } from '../apis/apiAuth';

// /////////////////////////////////////////////////////////////////////////////////////////////////
// Tags API - Cached by g_Auth.getOrgId()
// /////////////////////////////////////////////////////////////////////////////////////////////////
const entityKeys = (props = {}) => {
  const { entityType, filterByUserTags } = props;
  return [entityType, filterByUserTags ? 'Filtered' : 'NotFiltered', g_Auth.getOrgId()];
};
const idName = 'tagId';

//READ hook (get users from api)
export function useGetTags(props = {}) {
  return useQuery({
    queryKey: entityKeys(props),
    queryFn: async () => {
      const res = await Api.apiTagsGet(props).catch((err) => Promise.reject(err));
      if (res.status !== 200) {
        console.warn('Failed in apiTagsGet', res);
        return Promise.reject(res);
      }
      return res.dataJson;
    },
    refetchOnWindowFocus: false,
    retry: Q_DEF_RETRY,
    staleTime: Q_STALE_TMO_CFG,
  });
}

//CREATE hook (post new user to api)
export function useCreateTag(props = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (values) => {
      //send api update request here
      console.log('useCreateTag', 'mutationFn values:', values);
      const res = await Api.apiTagCreate(values);
      return Promise.resolve(res?.dataJson);
    },
    onMutate: (newInfo) => onMutateCreateT(queryClient, entityKeys(props), newInfo), //client side optimistic update
    onSettled: () => onSettledT(queryClient, entityKeys(props)),
  });
}

//UPDATE hook (put user in api)
export function useUpdateTag(props = {}) {
  const { entityType } = props;
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ values, origValues }) => mutationFnUpdateT({ values, origValues, entityType, updateCB: Api.apiTagUpdate }),
    onMutate: (newInfo) => onMutateUpdateT(queryClient, entityKeys(props), newInfo, idName), //client side optimistic update
    onSettled: () => onSettledT(queryClient, entityKeys(props)),
  });
}

//DELETE hook (delete user in api)
export function useDeleteTag(props = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id) => await Api.apiTagDelete(id),
    onMutate: (id) => onMutateDeleteT(queryClient, entityKeys(props), id, idName), //client side optimistic update
    onSettled: () => onSettledT(queryClient, entityKeys(props)),
  });
}
